import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as THREE from 'three';
var PointCloudNode = /*#__PURE__*/function (_THREE$EventDispatche) {
  _inherits(PointCloudNode, _THREE$EventDispatche);
  var _super = _createSuper(PointCloudNode);
  function PointCloudNode() {
    var _this;
    var numPoints = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var layer = arguments.length > 1 ? arguments[1] : undefined;
    _classCallCheck(this, PointCloudNode);
    _this = _super.call(this);
    _this.numPoints = numPoints;
    _this.layer = layer;
    _this.children = [];
    _this.bbox = new THREE.Box3();
    _this.sse = -1;
    return _this;
  }
  _createClass(PointCloudNode, [{
    key: "add",
    value: function add(node, indexChild) {
      this.children.push(node);
      node.parent = this;
      this.createChildAABB(node, indexChild);
    }
  }, {
    key: "load",
    value: function load() {
      var _this2 = this;
      // Query octree/HRC if we don't have children potreeNode yet.
      if (!this.octreeIsLoaded) {
        this.loadOctree();
      }
      return this.layer.source.fetcher(this.url, this.layer.source.networkOptions).then(function (file) {
        return _this2.layer.source.parse(file, {
          out: _this2.layer,
          "in": _this2.layer.source
        });
      });
    }
  }, {
    key: "findCommonAncestor",
    value: function findCommonAncestor(node) {
      if (node.depth == this.depth) {
        if (node.id == this.id) {
          return node;
        } else if (node.depth != 0) {
          return this.parent.findCommonAncestor(node.parent);
        }
      } else if (node.depth < this.depth) {
        return this.parent.findCommonAncestor(node);
      } else {
        return this.findCommonAncestor(node.parent);
      }
    }
  }]);
  return PointCloudNode;
}(THREE.EventDispatcher);
export default PointCloudNode;